import { isValidURL } from '~/util/Validation/URL';

/** Allows non-empty mailto, tel, and callto values, including flexible phone formats */
const CUSTOM_LINK_REGEX = /^(mailto:|tel:|callto:)\S.*$/;

/**
 * Returns true if the passed string is allowed as a link in the text editor
 * @param {string} str - string
 * keywords: link validation
 */
const isValidLink = (str: string): boolean =>
  isValidURL(str) || CUSTOM_LINK_REGEX.test(str);

export default isValidLink;
